import * as yup from "yup";
import { useTranslation } from "react-i18next";
import BaseForm from "../../../../../../../shared/components/form/BaseForm";
import FormInput from "../../../../../../../shared/components/input/FormInput";

const UpdateClientMarketForm = ({ market, onSubmitHandler }) => {
  const { t } = useTranslation();

  const validationSchema = yup.object({
    code: yup
      .string()
      .required(
        t("clients.detail.tabs.markets.updateForm.fields.code.required"),
      ),
    name: yup
      .string()
      .required(
        t("clients.detail.tabs.markets.updateForm.fields.name.required"),
      ),
  });

  const defaultValues = {
    code: market?.code,
    name: market?.name,
    description: market?.description,
  };

  return (
    <BaseForm
      validationSchema={validationSchema}
      defaultValues={defaultValues}
      onSubmitHandler={onSubmitHandler}
      isCreationForm={false}
    >
      <FormInput
        name="code"
        label={t("clients.detail.tabs.markets.updateForm.fields.code.label")}
        required
      />
      <FormInput
        name="name"
        label={t("clients.detail.tabs.markets.updateForm.fields.name.label")}
        required
      />
      <FormInput
        name="description"
        label={t(
          "clients.detail.tabs.markets.updateForm.fields.description.label",
        )}
      />
    </BaseForm>
  );
};

export default UpdateClientMarketForm;
